export default "__VITE_ASSET__DKjQCoXL__"